import { useEffect, useState } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { useParams } from 'react-router-dom';
import DocumentPDF from '../components/DetailsPDF/DocumentPDF';
import { cleanFilename, formatDateForFilename } from '../utils/converter';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import GradientBackground from '../components/GradientBackground/GradientBackground';
import { useAuth } from '../context/AuthContext';
import { historyService } from '../services/historyService';
import { blockchainService } from '../services/blockchainService';

const DetailsPDF = () => {
  const [reportData, setReportData] = useState<HistoryDetails | undefined>(undefined); // Data from history records
  const [blockHistory, setBlockHistory] = useState<any | null>(null); // Store the filtered item TODO fix type
  const { user } = useAuth(); // Get user information
  // const [imageSrc, setImageSrc] = useState<string | null>(null); // Image of chart

  // Extract the 'id' parameter from the route which is the 'hash' of the file data
  const { id } = useParams();

  /**
   * Fetches detailed blockchain history for the given 'id' and updates 'blockchainHistory' state
   */
  const getDetails = async () => {
    if (id) {
      try {
        const res = await historyService.getById(id);

        if (res.data.REQ_ID) {
          const blockchainRes = await blockchainService.getByReqId(res.data.REQ_ID);
          setBlockHistory(blockchainRes.data);
        } else {
          console.log('No REQ_ID found in history data');
        }

        setReportData(res.data);
      } catch (error) {
        console.error('Error in getDetails:', error);
      }
    }
  };

  useEffect(() => {
    getDetails(); // Fetch report data
  }, [id]);

  return (
    <>
      {reportData && reportData.TOKEN_ID && (
        <>
          <main className="overflow-hidden relative flex align-center justify-center flex-col">
            {/* Header with gradient background */}
            <div className="relative flex items-center h-20 md:h-[125px] px-4 sm:px-8 md:px-[60px]">
              <GradientBackground />
              <h1 className="z-10 text-2xl sm:text-3xl md:text-[40px] font-normal">PDF Report</h1>
            </div>

            {/* Main content */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-10 relative p-4 sm:p-8 md:p-[60px]">
              {/* PDF information */}
              <div className="flex flex-col gap-4 w-full lg:w-1/3">
                <div className="mb-6 p-4 border border-core-black-contrast-2 rounded-lg">
                  <h2 className="text-xl font-semibold text-minima-orange-2023 mb-4">PDF</h2>

                  <div className="space-y-3">
                    <div className="flex flex-col">
                      <span className="text-core-grey-60 text-xs font-medium uppercase tracking-wide">
                        Report for
                      </span>
                      <span className="text-white text-sm font-medium break-words">
                        {reportData.FILE_NAME}
                      </span>
                    </div>
                    {/* 
                    <div className="flex flex-col">
                      <span className="text-core-grey-60 text-xs font-medium uppercase tracking-wide">
                        Verification Date
                      </span>
                      <span className="text-white text-sm font-medium">
                        {formatDateForFilename(reportData.VALIDATION_DATE) || 'Unknown Date'}
                      </span>
                    </div> */}

                    {user?.name && (
                      <div className="flex flex-col">
                        <span className="text-core-grey-60 text-xs font-medium uppercase tracking-wide">
                          Generated for
                        </span>
                        <span className="text-white text-sm font-medium">{user.name}</span>
                      </div>
                    )}
                  </div>

                  {/* Download button */}
                  <div className="mt-6">
                    <PDFDownloadLink
                      document={<DocumentPDF reportData={reportData} blockHistory={blockHistory} />}
                      fileName={`${cleanFilename(
                        reportData.FILE_NAME,
                      )}_Verification_Report_${formatDateForFilename(
                        reportData.VALIDATION_DATE,
                      )}.pdf`}
                      className="btn-primary w-full bg-minima-orange-2023 hover:bg-minima-orange-light text-black cursor-pointer transition-colors duration-600 ease-in-out"
                    >
                      <DownloadIcon />
                      Download PDF
                    </PDFDownloadLink>
                  </div>
                </div>
              </div>

              {/* PDF viewer */}
              <div className="flex justify-center w-full lg:w-2/3">
                <div className="rounded-lg shadow-lg overflow-hidden border border-core-black-contrast-2 w-full">
                  <PDFViewer
                    // showToolbar={false}
                    // width="595px"
                    width="100%"
                    height="842px"
                    // style={{
                    //   // width: '595px',
                    //   width: '100%',
                    //   height: '842px',
                    //   border: 'none',
                    // }}
                    className="h-[500px] md:h-[842px]"
                  >
                    <DocumentPDF reportData={reportData} blockHistory={blockHistory} />
                  </PDFViewer>
                </div>
              </div>
            </div>
          </main>
        </>
      )}
    </>
  );
};

export default DetailsPDF;
